<template>
  <div id="wrapper">
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">Detalhes de Entrega de Prestação de Contas Mensal</span>
          <btn-voltar />
        </h6>
      </template>
      <b-tabs card>
        <b-tab title="Informações" active>
          <InformacoesEntregaPCM :idpcm="idpcm"></InformacoesEntregaPCM>
        </b-tab>
        <b-tab title="Relatórios" lazy>
          <RelatoriosPCM :idpcm="idpcm" @atualizarPcm="atualizarPcm"></RelatoriosPCM>
        </b-tab>
        <b-tab title="Assinatura Digital" lazy>
          <AssinaturaDigitalPCM :pcm="pcm"></AssinaturaDigitalPCM>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>
<script>
import BtnVoltar from '@/components/shared/BtnVoltar.vue'
import { UtilsTS } from '@/utilsts';
import { store } from "@/store"
import pcmService from "@/services/entregas/pcmService";

import AssinaturaDigitalPCM from './AssinaturaDigitalPCM.vue'
import InformacoesEntregaPCM from './InformacoesPCM.vue'
import RelatoriosPCM from './RelatoriosPCM.vue'

export default {
  name: "detalhes-pcm",
  mixins: [UtilsTS],
  components: {
    InformacoesEntregaPCM,
    RelatoriosPCM,
    AssinaturaDigitalPCM,
    BtnVoltar,
  },
  props: {
    idpcm: {
      type: String
    }
  },
  data() {
    return {
      pcm: null
    }
  },
  computed: {
  },
  methods: {
    async atualizarPcm() {
      try {
        this.pcm = await pcmService.getByID(this.idpcm)
      } catch (e) {
        console.error('Falha ao criar página DetalhesPCM', e)
        this.tratarError(e)
      }
    }
  },
  async created() {
    store.blockScreen = true
    try {
      this.atualizarPcm()
    } finally {
      store.blockScreen = false
    }
  }
};
</script>

<style>
#mensagemWrapper {
  width: 100% !important;
}

#mensagemWrapper.invalid .tox-tinymce {
  border: #dc3545 solid 1px !important;
  border-radius: 3px !important;
}

#mensagemWrapper.valid .tox-tinymce {
  border: #28a745 solid 1px !important;
  border-radius: 3px !important;
}

#mensagemWrapper label {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
  text-align: left;
}
</style>